<div class="container">
  <div class="row-justify-center large-text">
    <span>
      {{ appointment?.startTime | dateParser | weekdayFormatter }}
      {{ appointment?.startTime | dateParser | dateFormatter }}
    </span>

    <lib-spacer></lib-spacer>

    <span>|</span>

    <lib-spacer></lib-spacer>

    <span>
      {{ appointment?.startTime | dateParser | timeFormatter : true }}
    </span>
  </div>

  <ng-content select="[checkin-content]"></ng-content>

  @if (shouldDisplayAdvanceInfo()) {
  <lib-spacer></lib-spacer>
  <h2 class="text-align-center">
    {{ appointment?.owner | customerNameFormatter : businessObject?.telephone }}
  </h2>
  <lib-spacer [height]="5"></lib-spacer>
  <div
    *ngIf="appointment?.owner?.email"
    class="description-color text-align-center"
  >
    {{
      appointment?.owner?.email
        | emailFormatter : !shouldDisplayFullContactData()
    }}
  </div>
  <div
    *ngIf="appointment?.owner?.phoneNr"
    class="description-color text-align-center"
  >
    {{
      appointment?.owner?.phoneNr
        | phoneFormatter : !shouldDisplayFullContactData()
    }}
  </div>
  } @else if (businessObject) {
  <lib-spacer></lib-spacer>
  <h2 class="text-align-center">{{ businessObject?.name }}</h2>
  <div class="description-color text-align-center">
    {{ businessObject?.address }}
  </div>
  }

  <ng-container *ngIf="appointment?.note?.length && shouldDisplayAdvanceInfo()">
    <lib-spacer></lib-spacer>
    <div class="description-color text-align-center">
      {{ appointment?.note }}
    </div>
  </ng-container>

  <lib-spacer></lib-spacer>

  <div class="text-align-center">
    {{
      'lib_calendar.appointment-details.text.serve-by-staff'
        | translate
          : { staff: (staff | staffNameFormatter : appointment.staffId : true) }
    }}
  </div>

  <ng-container
    *ngIf="shouldDisplayAdvanceInfo() && appointment?.staffSelected"
  >
    <lib-spacer [height]="5"></lib-spacer>
    <div class="description-color text-align-center">
      ({{
        'lib_calendar.appointment-details.text.staff_selected_by_customer'
          | translate
      }})
    </div>
  </ng-container>

  <lib-spacer></lib-spacer>

  <div class="service-container">
    <ng-container *ngFor="let product of appointment.services">
      <div>
        {{ product.name }}
      </div>

      <div class="row-space-between description-color">
        <div>
          {{ product.duration * 60 | durationFormatter }}
        </div>
        <lib-spacer></lib-spacer>
        <div>
          {{ product.price | roundNumberFormatter }}
          <ng-container *ngIf="businessObject?.currency">{{
            businessObject.currency
          }}</ng-container>
        </div>
      </div>

      <lib-spacer [height]="10"></lib-spacer>
    </ng-container>

    <lib-divider></lib-divider>
    <lib-spacer [height]="10"></lib-spacer>

    <div class="row-space-between">
      <div class="large-text">
        {{ 'lib_calendar.appointment-details.text.total' | translate }}
      </div>

      <lib-spacer></lib-spacer>

      <div style="text-align: end">
        <div>
          <strong
            >{{ totalPrice | roundNumberFormatter }}
            <ng-container *ngIf="businessObject?.currency">{{
              businessObject.currency
            }}</ng-container>
          </strong>
        </div>
        <div class="description-color">
          {{ totalDuration * 60 | durationFormatter }}
        </div>
      </div>
    </div>
  </div>
</div>
